import { useEffect, useState } from 'react';

/**
 * A hook to detect the global navbar
 */
export const useDetectGlobalNavbar = () => {
  const [isGlobalNavbarShown, setGlobalNavbarShown] = useState(false);
  const [globalNavbarHeight, setGlobalNavbarHeight] = useState(0);

  useEffect(() => {
    const navbar = document.querySelector('.global-navbar-root');

    const observer = new MutationObserver((mutations) => {
      // eslint-disable-next-line no-restricted-syntax
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const element = mutation.target as HTMLElement;

          const classList = element.classList;

          if (classList.contains('global-navbar-root')) {
            setGlobalNavbarShown(!classList.contains('hidden-on-scroll-down'));
          }
        }
      }
    });

    if (navbar) {
      observer.observe(navbar, {
        attributes: true,
      });
      setGlobalNavbarHeight(navbar.scrollHeight);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return { isShown: isGlobalNavbarShown, navbarHeight: globalNavbarHeight };
};
